export default "__VITE_ASSET__DBp5JCRx__"